import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './img/uestc/logo2.svg';
import _imports_1 from './img/uestc/figure1.jpg';
const _hoisted_1 = {
  class: "success-case"
};
const _hoisted_2 = {
  class: "success-case-banner"
};
const _hoisted_3 = {
  class: "case-info"
};
const _hoisted_4 = {
  class: "case-name"
};
const _hoisted_5 = {
  class: "tit"
};
const _hoisted_6 = {
  class: "case-title"
};
const _hoisted_7 = {
  class: "case-title"
};
const _hoisted_8 = {
  class: "desc"
};
const _hoisted_9 = {
  class: "doc-btn"
};
const _hoisted_10 = {
  class: "breadcrumb-box"
};
const _hoisted_11 = {
  class: "page-title"
};
const _hoisted_12 = {
  class: "customer-message"
};
const _hoisted_13 = {
  class: "message-info"
};
const _hoisted_14 = {
  class: "message-txt"
};
const _hoisted_15 = {
  class: "principal"
};
const _hoisted_16 = {
  class: "page-title"
};
const _hoisted_17 = {
  class: "thema-desc"
};
const _hoisted_18 = {
  class: "page-title"
};
const _hoisted_19 = {
  class: "thema-desc"
};
const _hoisted_20 = {
  class: "thema-desc"
};
const _hoisted_21 = {
  class: "emphasis"
};
const _hoisted_22 = {
  class: "thema-desc"
};
const _hoisted_23 = {
  class: "thema-desc"
};
const _hoisted_24 = {
  class: "bottom-banner"
};
const _hoisted_25 = {
  class: "banner-con"
};
const _hoisted_26 = {
  class: "title"
};
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'uestc',
  setup(__props) {
    const advisoryServiceRef = ref(null);
    const goAdvisory = () => {
      advisoryServiceRef['value'].show();
    };
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      const _component_AdvisoryService = _resolveComponent("AdvisoryService");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "logo-box"
      }, [_createElementVNode("img", {
        src: _imports_0
      })], -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('successCase.text1')), 1)]), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('successCase.text2')), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('successCase.text3')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('successCase.text4')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('successCase.text111')), 1)])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
          to: {
            path: '/successCase'
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('successCase.text75')), 1)]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('successCase.text112')), 1)]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('successCase.text6')), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('successCase.text7')), 1), _createElementVNode("p", _hoisted_15, "— " + _toDisplayString(_ctx.$t('successCase.text8')), 1)])]), _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t('successCase.text9')), 1), _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('successCase.text10')), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "thema-figure"
      }, [_createElementVNode("img", {
        class: "thema-img",
        src: _imports_1
      })], -1)), _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t('successCase.text11')), 1), _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('successCase.text12')), 1), _createElementVNode("p", _hoisted_20, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('successCase.text13')), 1), _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('successCase.text14')), 1)]), _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('successCase.text15')), 1), _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('successCase.text16')), 1), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t('successCase.text17')), 1), _createElementVNode("span", {
        class: "consult-btn",
        onClick: goAdvisory
      }, _toDisplayString(_ctx.$t('successCase.text18')), 1)])]), _createVNode(_component_AdvisoryService, {
        ref_key: "advisoryServiceRef",
        ref: advisoryServiceRef
      }, null, 512)]);
    };
  }
});